<template>
  <FourElement></FourElement>
  <div class="collection-container">
    <List></List>
    <AddModal></AddModal>
  </div>
</template>

<script>
import FourElement from './components/FourElement.vue'
import List from './components/List.vue'
import AddModal from './components/AddModal.vue'
import { onMounted, reactive, provide, toRefs } from 'vue'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'
import {
  queryAllLiveRooms,
  queryPageLiveNotify,
  addLiveNotify,
  updateLiveNotify,
  deleteLiveNotify
} from 'server/modules/live'
import { common_lang_getAll } from 'server/modules/3426'
// import useAPI from 'UseApi'
// const { common_querySiteInfo_get_ } = useAPI(null, [3426])

export default {
  components: {
    FourElement,
    List,
    AddModal
  },
  setup() {
    const state = reactive({
      searchParams: {
        terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      pagination: {
        current: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        total: 0,
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTabList()
        }
      },
      //语言数据
      langList: [],
      //表格数据
      dataSource: [],
      //直播间数据
      liveRoomSelect: [],
      brands: [],
      channels: [],
      sites: [],
      //列
      columns: [
        {
          title: '序号',
          align: 'center',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '通知内容',
          dataIndex: 'content',
          key: 'content',
          align: 'center'
        },
        {
          title: '展示时长',
          align: 'center',
          dataIndex: 'duration',
          key: 'duration'
        },
        {
          title: '发送时间',
          dataIndex: 'sendTime',
          key: 'sendTime',
          align: 'center'
        },
        {
          title: '直播间',
          align: 'center',
          dataIndex: 'liveName',
          key: 'liveName'
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operate',
          align: 'center'
        }
      ],
      initList: () => {
        state.getTabList()
        state.getLiveRoomList()
        state.initCommonLang()
      },
      //table数据
      getTabList: () => {
        const param = {
          pageNum: state.pagination.current,
          pageSize: state.pagination.pageSize
        }
        queryPageLiveNotify(param)
          .then(e => {
            if (e.success) {
              state.dataSource = e.data.data.list.records
              state.pagination.total = e.data.data.total
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      getLiveRoomList() {
        queryAllLiveRooms()
          .then(e => {
            if (e.success) {
              state.liveRoomSelect = e.data.data
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      initCommonLang: async () => {
        const param = {
          pageNum: 1,
          pageSize: 100
        }
        const { data } = await common_lang_getAll(param)
        const list = []
        data.list.map(item => {
          list.push({
            label: item.langCn,
            value: item.langCode
          })
        })
        state.langList = list
      },
      modalVisible: false,
      formRef: null,
      form: {
        content: [
          {
            key: undefined,
            value: undefined
          }
        ]
      },
      //校验
      rules: {
        content: [{ required: true, message: '请输入通知内容！' }],
        liveId: [{ required: true, message: '请选择直播间！' }]
        // duration: [{ required: true, message: '请确定展示时长！' }],
        // sendTime: [{ required: true, message: '请确定发送时间！' }]
      },
      add: () => {
        state.modalVisible = true
      },
      selectDuration() {
        if (state.form.type1 === '1') {
          state.form.duration = ''
        } else {
          state.form.duration = ''
        }
      },
      selectSendTime() {
        if (state.form.type2 === '1') {
          state.form.sendTime = ''
        } else {
          state.form.sendTime = ''
        }
      },
      selectDate() {
        console.log(dayjs(state.form.sendTime).format('YYYY-MM-DD HH:mm:ss'))
      },
      addContent() {
        state.form.content.push({
          key: undefined,
          value: undefined
        })
        console.log(state.form.content)
      },
      removeContent: info => {
        if (state.form.content.length > 1) {
          const index = state.form.content.indexOf(info)
          if (index !== -1) {
            state.form.content.splice(index, 1)
          }
        }
      },
      modalCancel: () => {
        state.formRef.clearValidate()
        state.form = {
          content: [
            {
              key: undefined,
              value: undefined
            }
          ]
        }
        state.modalVisible = false
      },
      modalSubmit: async () => {
        state.formRef
          .validateFields()
          .then(() => {
            const param = {
              ...state.form
            }
            if (param.type2 === '1') {
              param.sendTime = null
            } else {
              param.sendTime = dayjs(param.sendTime).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            }
            if (param.type1 === '1') {
              param.duration = 0
            }
            param.content = JSON.stringify(param.content)
            if (param.id) {
              updateLiveNotify(param)
                .then(e => {
                  if (e.success) {
                    message.success('更新成功')
                    state.formRef.clearValidate()
                    state.form = {
                      content: [
                        {
                          key: undefined,
                          value: undefined
                        }
                      ]
                    }
                    state.modalVisible = false
                    state.initList()
                  } else {
                    message.warning(e.data)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            } else {
              addLiveNotify(param)
                .then(e => {
                  if (e.success) {
                    if (e.data.succes) {
                      message.success('添加成功')
                      state.formRef.clearValidate()
                      state.form = {
                        content: [
                          {
                            key: undefined,
                            value: undefined
                          }
                        ]
                      }
                      state.modalVisible = false
                      state.initList()
                    } else {
                      message.warning(e.data.data)
                    }
                  } else {
                    message.warning(e.retInfo)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            }
          })
          .catch(e => {
            console.log('e: ', e)
          })
      },
      handleEdit: info => {
        if (info) {
          state.form = {
            ...info,
            sendTime: info.immediately === 1 ? dayjs(info.sendTime) : '',
            type2: info.immediately === 0 ? '1' : '2',
            type1: info.duration === 0 ? '1' : '2',
            content: JSON.parse(info.content)
          }
          state.modalVisible = true
        }
      },
      handleDel: info => {
        if (info) {
          deleteLiveNotify(info)
            .then(e => {
              if (e.success) {
                message.success('删除成功')
                state.initList()
              } else {
                message.warning(e.data)
              }
            })
            .catch(err => {
              console.log('err: ', err)
              message.warning(err.retInfo)
            })
        }
      }
    })
    onMounted(() => {
      // common_querySiteInfo_get_({
      //   state
      // })
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.container-three {
  padding: 40px;
  background-color: #fff;
}
</style>
